<div class="image-container">
  <div class="m-2 container">
    <div class="title my-2 d-flex flex-row justify-content-between">
      Upload image or file
      <button [mat-dialog-close]="data" class="btn my-btn noborder" mat-dialog-close (click)="onExitClick()">
        <span class="mdi--window-close noborder"></span>
      </button>
    </div>
    @if (url.length > 0) {
      <button [mat-dialog-close]="data" mat-icon-button mat-dialog-close matTooltip="Dodaj do tablicy" matTooltipShowDelay="2000" cdkFocusInitial (click)="onAddClick()">
        <i class="icon material-icons-outlined">post_add</i>
      </button>
    }
  
  </div>
  <app-uploadfile [organizationKey]="organizationKey" [objectType]="'content'" [userId]="userId" [contentKey]="contentKey" [imageOnly]="imagesOnly" (isFileUploaded)="isFileUploaded($event)" [projectName]="projectName" [projectKey]="projectKey" [embbeddingModel]="embeddingModel"></app-uploadfile>
  
  @if (storageUrl.length > 0) {
    <div>
      <img src="{{url}}" class="image" id="image" />
    </div>
  }
</div>


